<style scoped lang="scss">
  form {
      h2 {
          color: #000;
      }
      ::v-deep(.formkit-select-icon) {
          height: 50px;
          margin: 0;
          padding: 0;
      }
  }
  main .container .card {
    background-color: rgba(91, 91, 98, 0.08);
  }
</style>
<template>
    <button
        :id="redirectToLastPageBtnId"
        class="inline-flex items-center px-4 py-2 border border-blue-500 text-blue-500 bg-white transition-colors duration-300 hover:bg-blue-500 hover:text-white rounded-md text-sm"
        @click="redirectToLastPage()"
    >
        <svg class="w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
        Retour
    </button>
    
    <div class="mt-5 mb-5">
        <h1 class="page-title">AJOUTER DES FILTRES</h1>
    </div>

    <div v-if="isLoading" class="flex justify-content-center">
        <ProgressSpinner aria-label="Chargement" />
    </div>
    <div v-else class="max-w-screen-xl mx-auto">
        <div class="flex flex-wrap justify-center">
            <FormKit type="form"
                 :id="formId"
                 :actions="false"
                 :model="form"
                 @submit="onSubmit"
                 outer-class="w-full"
                 incomplete-message="Veuillez remplir tous les champs correctement"
                 #default="{ state: { valid } }"
            >
                <FormKit
                    type="select"
                    name="status"
                    label="Type de filtre *"
                    disabled
                    :options="[{ label: 'Propriété', value: 'property' }]"
                    :validation-messages="{required: 'Veuillez selectionner un type de filtre.'}"
                />
                <FormKit type="autocomplete"
                    name="properties"
                    v-model="form.properties"
                    label="Propriété filtrable *"
                    placeholder="Choisissez une propriété"
                    multiple
                    validation="required"
                    selection-appearance="option"
                    empty-message="Aucune propriété trouvée"
                    :options="propertiesForInputAutocomplete"
                    :validation-messages="{required: 'Veuillez sélectionner une ou plusieurs propriétés.'}"
                />
                <FormKit type="submit" label="Ajouter" :disabled="!valid" />
            </FormKit>
        </div>
    </div>
</template>

<script lang="ts" setup>
import {onMounted, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import { ICategoryFilterForm } from "@/models/filter/category/ICategoryFilterForm";
import { IPropertyNotLinkedToCategoryFilter } from "@/models/filter/property/IPropertyNotLinkedToCategoryFilter";
import { filterService } from "@/_services/filter/category/filter";
import ProgressSpinner from "primevue/progressspinner";

const route = useRoute();
const router = useRouter();
const categoryUuidRouteParam = ref<string | null>(null);
const form = ref<ICategoryFilterForm>({
    category: '',
    properties: null,
});
const isLoading = ref<boolean>(false);
const formId = 'add-category-filter-form';
const redirectToLastPageBtnId = 'go-back-on-last-page';

onMounted(async () => {
    categoryUuidRouteParam.value = route.params.uuid as string;
    if (categoryUuidRouteParam.value) {
        await getFilterNamesForInputAutoComplete();
    }
});

interface IAutocompleteInputItem {
    label: string;
    value: string;
}

const propertiesForInputAutocomplete = ref<Array<IAutocompleteInputItem>>([]);
const getFilterNamesForInputAutoComplete = () => {
    isLoading.value = true;

    return new Promise<void>((resolve, reject) => {
        ApiService.get(
            `admin/prototype-not_linked-to-category/${categoryUuidRouteParam.value}`, {
                params: { itemsPerPage: 500 },
                headers: { Accept: "application/json" },
            })
            .then((response) => {
                const data = response.data.data;
                propertiesForInputAutocomplete.value = data.map((item: IPropertyNotLinkedToCategoryFilter) => ({
                    label: item.filterName,
                    value: item.filterPropertyUuid
                }));
                resolve();
                isLoading.value = false;
            })
            .catch((error) => {
                reject(error);
            });
    });
}

const showSpinner = () => {
    isLoading.value = true;

    const formHTMLElement = document.getElementById(`${formId}`);
    if (formHTMLElement) {
        const submitBtn = formHTMLElement.querySelector('button[type="submit"]');
        const redirectToLastPageBtn = document.getElementById(`${redirectToLastPageBtnId}`);
        if (submitBtn && redirectToLastPageBtn) {
            submitBtn.disabled = true;
            redirectToLastPageBtn.disabled = true;
        }
    }
}

const hideSpinner = () => {
    isLoading.value = false;
}

const onSubmit = async (formData, formNode) => {
    const payload: ICategoryFilterForm = {
        category: categoryUuidRouteParam.value as string,
        properties: formData.properties,
    }
    
    swal.confirm(`Êtes-vous sur de vouloir ajouter le filtre ?`, "Annuler", "Oui")
        .then((responseLevel1: object) => {
            if (responseLevel1.isConfirmed) {
                showSpinner();
                filterService.createCategoryFilter(payload).then(() => {
                    hideSpinner();
                    swal.success("Succès !", "Le filtre a été créer avec succès !")
                        .then((responseLevel2) => {
                        if (responseLevel2.isConfirmed) {
                            setTimeout(() => {
                                router.push({ name: 'categoryProductFiltersManagement', params: { uuid: payload.category }});
                            }, 1000);
                        }
                    });
                });
            }
        });
};

const redirectToLastPage = () => {
    router.back();
};
</script>